import { render, staticRenderFns } from "./_orders.tab.vue?vue&type=template&id=dab6ac3a&scoped=true"
import script from "./_orders.tab.vue?vue&type=script&lang=js"
export * from "./_orders.tab.vue?vue&type=script&lang=js"
import style0 from "./_orders.tab.vue?vue&type=style&index=0&id=dab6ac3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab6ac3a",
  null
  
)

export default component.exports